import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../CustomComponents/AccordianContainer";
import CustomTextField from "../../CustomComponents/CustomTextField";
import CustomDataGrid from "../../CustomComponents/CustomDataGrid";
import { customerAddressColumn, customerDocumentsColumn } from "./CustomerInfoHelper";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import PageNotFound from "../../CustomComponents/PageNotFound";
import StlapFooter from "../../CustomComponents/StlapFooter";
import { convertDateWithValidation } from "../helper/losDataHelper";
import { useDispatch } from "react-redux";
import { SpinnerReduerAction } from "../../Store/spinner/SpinnerReducer";
import CustomSpinner from "../../CustomComponents/CustomSpinner";

const CustomerInfo = () => {

  const dispatch = useDispatch();

  const { internalCustomerId } = useParams();
  const [documentValues, setDocumentValues] = useState(null);
  const [customerAddressValues, setCustomerAddressValues] = useState(null);
  const [customerInfo, setCustomerInfo] = useState([]);
  const [invalidID, setInvalidID] = useState(false);

  useEffect(() => {
    loadCustomerInformation();
  },[]);

  const loadCustomerInformation = async() => {
    dispatch(SpinnerReduerAction.updateSpinnerFlag(true));
    let newAxiosBase = { ...axios };
    newAxiosBase.defaults.baseURL =
      process.env.REACT_APP_STLAP_LOS_DATA_BACKEND;
      try {
        await newAxiosBase.post("/stlap/getCustomerInformationById", { internalCustomerId }).then(res => {
          setDocumentValues(res.data['documents']);
          setCustomerAddressValues(res.data['customerAddresses'])
          setCustomerInfo(res.data);
      });
      } catch {
          setInvalidID(true);
      }
      dispatch(SpinnerReduerAction.updateSpinnerFlag(false));
  }

    return(<>
    <CustomSpinner />
    { invalidID ? <PageNotFound /> :
         <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          id="accord"
          title="Customer Information"
          initialOpen={true}
        >
           <Box sx={{ marginTop: "-1%" }}>
          <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Internal Customer ID"
                variant="standard"
                placeholder="Enter Internal Customer ID"
                disabled={true}
                value={customerInfo.internalCustomerId}
              />
              </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Internal Application ID"
                variant="standard"
                placeholder="Enter Internal Application ID"
                disabled={true}
                value={customerInfo.internalApplicationId}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Customer ID"
                variant="standard"
                placeholder="Enter Customer ID"
                disabled={true}
                value={customerInfo.customerId}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="PAN Number"
                variant="standard"
                placeholder="Enter PAN Number"
                disabled={true}
                value={customerInfo.panNum}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="First Name"
                variant="standard"
                placeholder="Enter First Name"
                disabled={true}
                value={customerInfo.firstName}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Middle Name"
                variant="standard"
                placeholder="Enter Middle Name"
                disabled={true}
                value={customerInfo.middleName}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Sur Name"
                variant="standard"
                placeholder="Enter Sur Name"
                disabled={true}
                value={customerInfo.surName}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="DOB"
                variant="standard"
                placeholder="Enter DOB"
                disabled={true}
                value={convertDateWithValidation(customerInfo.dateOfBirth)}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Gender ID"
                variant="standard"
                placeholder="Enter Gender ID"
                disabled={true}
                value={customerInfo.genderId}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Gender Type"
                variant="standard"
                placeholder="Enter Gender Type"
                disabled={true}
                value={customerInfo.genderType}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Marital Status"
                variant="standard"
                placeholder="Enter Marital Status"
                disabled={true}
                value={customerInfo.maritalStatus}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Spouse Name"
                variant="standard"
                placeholder="Enter Spouse Name"
                disabled={true}
                value={customerInfo.spouseName}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Father Name"
                variant="standard"
                placeholder="Enter Father Name"
                disabled={true}
                value={customerInfo.fatherName}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Mother Name"
                variant="standard"
                placeholder="Enter Mother Name"
                disabled={true}
                value={customerInfo.motherName}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Qualification ID"
                variant="standard"
                placeholder="Enter Qualification ID"
                disabled={true}
                value={customerInfo.qualificationId}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Qualification"
                variant="standard"
                placeholder="Enter Qualification"
                disabled={true}
                value={customerInfo.qualification}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Mobile Number"
                variant="standard"
                placeholder="Enter Mobile Number"
                disabled={true}
                value={customerInfo.mobileNumber}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Email ID"
                variant="standard"
                placeholder="Enter Email ID"
                disabled={true}
                value={customerInfo.emailId}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Address ID"
                variant="standard"
                placeholder="Enter Address ID"
                disabled={true}
                value={customerInfo.addressId}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Address Type"
                variant="standard"
                placeholder="Enter Address Type"
                disabled={true}
                value={customerInfo.addressType}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Flat/ Door/ Building/ Block"
                variant="standard"
                placeholder="Enter Flat/ Door/ Building/ Block"
                disabled={true}
                value={customerInfo.flatDoorBuildingBlock}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Road / Street"
                variant="standard"
                placeholder="Enter Road / Street"
                disabled={true}
                value={customerInfo.roadStreet}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Area / Locality"
                variant="standard"
                placeholder="Enter Area / Locality"
                disabled={true}
                value={customerInfo.areaLocality}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="City / Town"
                variant="standard"
                placeholder="Enter City / Town"
                disabled={true}
                value={customerInfo.cityTown}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="State"
                variant="standard"
                placeholder="Enter State"
                disabled={true}
                value={customerInfo.state}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="LandMark"
                variant="standard"
                placeholder="Enter LandMark"
                disabled={true}
                value={customerInfo.landmark}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Pincode"
                variant="standard"
                placeholder="Enter Pincode"
                disabled={true}
                value={customerInfo.pincode}
              />
              </Grid>  
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Is Residential Same As Permanent"
                variant="standard"
                placeholder="Enter Is Residential Same As Permanent"
                disabled={true}
                value={customerInfo.isResidentialSameAsPermanent}
              />
              </Grid> 
             
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Capacity Code"
                variant="standard"
                placeholder="Enter Capacity Code"
                disabled={true}
                value={customerInfo.capacityCode}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Capacity Name"
                variant="standard"
                placeholder="Enter Capacity Name"
                disabled={true}
                value={customerInfo.capacityName}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Customer Business Detail ID"
                variant="standard"
                placeholder="Enter Customer Business Detail ID"
                disabled={true}
                value={customerInfo.customerBusinessDetailId}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Name of Business"
                variant="standard"
                placeholder="Enter Name of Business"
                disabled={true}
                value={customerInfo.nameOfBusiness}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Non Registered Business Name"
                variant="standard"
                placeholder="Enter Non Registered Business Name"
                disabled={true}
                value={customerInfo.nonRegisteredBusinessName}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Total Work Experience"
                variant="standard"
                placeholder="Enter Total Work Experience"
                disabled={true}
                value={customerInfo.totalWorkExperience}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Years In Current Business"
                variant="standard"
                placeholder="Enter Years In Current Business"
                disabled={true}
                value={customerInfo.yearsInCurrentBusiness}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Business Type ID"
                variant="standard"
                placeholder="Enter Business Type ID"
                disabled={true}
                value={customerInfo.businessTypeId}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Business Type"
                variant="standard"
                placeholder="Enter Business Type"
                disabled={true}
                value={customerInfo.businessType}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Business Category ID"
                variant="standard"
                placeholder="Enter Business Category ID"
                disabled={true}
                value={customerInfo.businessCategoryId}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Business Category"
                variant="standard"
                placeholder="Enter Business Category"
                disabled={true}
                value={customerInfo.businessCategory}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Business Property ID"
                variant="standard"
                placeholder="Enter Business Property ID"
                disabled={true}
                value={customerInfo.businessPropertyId}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Business License Number"
                variant="standard"
                placeholder="Enter Business License Number"
                disabled={true}
                value={customerInfo.businessLicenseNum}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Business Property"
                variant="standard"
                placeholder="Enter Business Property"
                disabled={true}
                value={customerInfo.businessProperty}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="GST Registration Number"
                variant="standard"
                placeholder="Enter GST Registration Number"
                disabled={true}
                value={customerInfo.gstRegNum}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="UAM MSME Number"
                variant="standard"
                placeholder="Enter UAM MSME Number"
                disabled={true}
                value={customerInfo.uammsmeNumber}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Size Of Shop"
                variant="standard"
                placeholder="Enter Size Of Shop"
                disabled={true}
                value={customerInfo.sizeOfShop}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="ITR"
                variant="standard"
                placeholder="Enter ITR"
                disabled={true}
                value={customerInfo.itr}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Loan ID"
                variant="standard"
                placeholder="Enter Loan ID"
                disabled={true}
                value={customerInfo.loanId}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Loan Amount"
                variant="standard"
                placeholder="Enter Loan Amount"
                disabled={true}
                value={customerInfo.loanAmount}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Institution Name"
                variant="standard"
                placeholder="Enter Institution Name"
                disabled={true}
                value={customerInfo.institutionName}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="EMI Amount"
                variant="standard"
                placeholder="Enter EMI Amount"
                disabled={true}
                value={customerInfo.emiAmount}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Is Deleted"
                variant="standard"
                placeholder="Enter Is Deleted"
                disabled={true}
                value={customerInfo.isDeleted}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Relationship With Applicant"
                variant="standard"
                placeholder="Enter Relationship With Applicant"
                disabled={true}
                value={customerInfo.relationshipWithApplicant}
              />
              </Grid> 

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Bureau Reference ID"
                variant="standard"
                placeholder="Enter Bureau Reference ID"
                disabled={true}
                value={customerInfo.bureauReferenceId}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Is Bureau Checked"
                variant="standard"
                placeholder="Enter Is Bureau Checked"
                disabled={true}
                value={customerInfo.isBureauChecked}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Generated Date"
                variant="standard"
                placeholder="Enter Generated Date"
                disabled={true}
                value={convertDateWithValidation(customerInfo.generatedDate)}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Is Eligible"
                variant="standard"
                placeholder="Enter Is Eligible"
                disabled={true}
                value={customerInfo.isEligible}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Title ID"
                variant="standard"
                placeholder="Enter Title ID"
                disabled={true}
                value={customerInfo.titleId}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="File Status"
                variant="standard"
                placeholder="Enter File Status"
                disabled={true}
                value={customerInfo.fileStatus}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Cibil Score"
                variant="standard"
                placeholder="Enter Cibil Score"
                disabled={true}
                value={customerInfo.cibilScore}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="religion ID"
                variant="standard"
                placeholder="Enter religion ID"
                disabled={true}
                value={customerInfo.religionId}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Religion"
                variant="standard"
                placeholder="Enter Religion"
                disabled={true}
                value={customerInfo.region}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Specify Other Religion"
                variant="standard"
                placeholder="Enter Specify Other Religion"
                disabled={true}
                value={customerInfo.specifyOtherReligion}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Caste ID"
                variant="standard"
                placeholder="Enter Caste ID"
                disabled={true}
                value={customerInfo.casteId}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Caste Name"
                variant="standard"
                placeholder="Enter Caste Name"
                disabled={true}
                value={customerInfo.casteName}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Risk Category ID"
                variant="standard"
                placeholder="Enter Risk Category ID"
                disabled={true}
                value={customerInfo.riskCtrId}
              />
              </Grid>  
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Risk Category"
                variant="standard"
                placeholder="Enter Risk Category"
                disabled={true}
                value={customerInfo.riskCategory}
              />
              </Grid> 
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="MSME"
                variant="standard"
                placeholder="Enter MSME"
                disabled={true}
                value={customerInfo.msme ? "YES" : "NO"}
              />
              </Grid>
              </Grid>
              </Box>
            </AccordianContainer>

            <AccordianContainer
          id="accord"
          title="Documents"
          initialOpen={false}
        >
          <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={documentValues !== null ?
              documentValues.map((item, index) => ({
                id: index + 1,
                ...item,
              })) : []
            }
            columns={customerDocumentsColumn}
            pageSize={15}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.documentDetailsId}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
          </Box>
          </AccordianContainer>
          <AccordianContainer
          id="accord"
          title="Customer Address Details"
          initialOpen={false}
        >
          <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={customerAddressValues !== null ?
              customerAddressValues.map((item, index) => ({
                id: index + 1,
                ...item,
              })) : []
            }
            columns={customerAddressColumn}
            pageSize={15}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.addressId}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
          </Box>
          </AccordianContainer>
            </Box> }
            <StlapFooter />
    </>);
}

export default CustomerInfo;